import {ConversationDto} from "../dto/ConversationDto";

export const sortConversations = (
    conversations: ConversationDto[],
    sortBy: 'id' | 'start' | 'duration' | 'turns' | null,
    sortDirection: 'asc' | 'desc'
): ConversationDto[] => {
    if (!sortBy) return [...conversations];

    return [...conversations].sort((a, b) => {
        let aValue: string | number | Date;
        let bValue: string | number | Date;

        switch (sortBy) {
            case 'id':
                aValue = a.conversationId;
                bValue = b.conversationId;
                break;
            case 'start':
                aValue = new Date(a.startTime);
                bValue = new Date(b.startTime);
                break;
            case 'duration':
                aValue = a.duration;
                bValue = b.duration;
                break;
            case 'turns':
                aValue = a.interactionCount;
                bValue = b.interactionCount;
                break;
            default:
                return 0;
        }

        if (aValue < bValue) return sortDirection === 'asc' ? -1 : 1;
        if (aValue > bValue) return sortDirection === 'asc' ? 1 : -1;
        return 0;
    });
};